// components/SessionWarningModal.jsx
import React, { useEffect, useState } from 'react';

const SessionWarningModal = ({ timeLeft, onContinue, onLogout }) => {
    const [isClosing, setIsClosing] = useState(false);

    // Auto logout cuando el tiempo llegue a 0
    useEffect(() => {
        if (timeLeft === 0) {
            handleAutoLogout();
        }
    }, [timeLeft]);

    const handleAutoLogout = () => {
        setIsClosing(true);
        setTimeout(() => {
            onLogout();
        }, 300);
    };

    const handleContinue = () => {
        setIsClosing(true);
        setTimeout(() => {
            onContinue();
        }, 200);
    };

    const handleLogout = () => {
        setIsClosing(true);
        setTimeout(() => {
            onLogout();
        }, 200);
    };

    // Formatear tiempo para mostrar en formato mm:ss
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    // Calcular porcentaje de tiempo restante
    const progressPercentage = (timeLeft / 30) * 100;

    return (
        <div className={`
      fixed inset-0 bg-black bg-opacity-85 backdrop-blur-sm
      flex justify-center items-center z-50
      transition-all duration-300
      ${isClosing ? 'animate-fadeOut' : 'animate-fadeIn'}
    `}>
            <div className={`
        bg-gradient-to-br from-white to-gray-50
        p-8 rounded-2xl text-center max-w-md w-[90%]
        shadow-2xl border border-red-200
        transform transition-all duration-300
        ${isClosing ? 'animate-slideOut' : 'animate-slideIn'}
      `}>
                {/* Icono de advertencia */}
                <div className="mb-4 animate-pulse">
                    <svg viewBox="0 0 24 24" width="48" height="48" className="mx-auto">
                        <path
                            fill="#ff6b6b"
                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                        />
                    </svg>
                </div>

                <h2 className="text-red-500 text-2xl font-bold mb-4">
                    ⚠️ Tu sesión está por expirar
                </h2>

                <p className="text-gray-700 mb-4 text-base leading-relaxed">
                    Por seguridad, tu sesión se cerrará automáticamente en
                    <span className="text-red-500 text-xl font-bold bg-red-50 px-2 py-1 rounded-lg mx-1 inline-block">
                        {formatTime(timeLeft)}
                    </span>
                    segundos si no realizas ninguna acción.
                </p>

                {/* Barra de progreso */}
                <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden my-6">
                    <div
                        className="h-full bg-gradient-to-r from-red-500 to-red-400 rounded-full transition-all duration-1000 animate-pulse"
                        style={{ width: `${progressPercentage}%` }}
                    />
                </div>

                {/* Caja de mensaje */}
                <div className="bg-blue-50 border-l-4 border-green-500 p-4 my-4 text-left rounded-lg">
                    <p className="text-gray-800 mb-2 font-semibold">💡 ¿Qué deseas hacer?</p>
                    <ul className="text-gray-600 space-y-1 text-sm">
                        <li>✅ <strong>Continuar sesión</strong>: Renovaremos tu sesión automáticamente</li>
                        <li>❌ <strong>Cerrar sesión</strong>: Finalizarás tu sesión de forma segura</li>
                    </ul>
                </div>

                {/* Botones */}
                <div className="flex gap-3 justify-center mt-6">
                    <button
                        onClick={handleContinue}
                        className="flex-1 bg-gradient-to-r from-green-500 to-green-600 
                       text-white font-semibold py-3 px-4 rounded-xl
                       transition-all duration-300 hover:shadow-lg 
                       hover:from-green-600 hover:to-green-700
                       active:transform active:scale-95"
                    >
                        🔄 Sí, continuar sesión
                    </button>

                    <button
                        onClick={handleLogout}
                        className="flex-1 bg-gradient-to-r from-red-500 to-red-600 
                       text-white font-semibold py-3 px-4 rounded-xl
                       transition-all duration-300 hover:shadow-lg
                       hover:from-red-600 hover:to-red-700
                       active:transform active:scale-95"
                    >
                        🚪 Cerrar sesión
                    </button>
                </div>

                {/* Botón cerrar */}
                <button
                    onClick={handleLogout}
                    className="absolute top-4 right-4 text-gray-400 hover:text-red-500 
                     transition-colors duration-300 w-8 h-8 flex items-center 
                     justify-center rounded-full hover:bg-gray-100"
                    title="Cerrar"
                >
                    ✕
                </button>
            </div>
        </div>
    );
};

export default SessionWarningModal;